// country selected by user

import { createSlice } from "@reduxjs/toolkit";

export const countrySlice = createSlice({
  name: "country",
  initialState: {
    value: null,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = null;
    },
  },
});

export const { update, reset } = countrySlice.actions;

export default countrySlice.reducer;
